import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

export default function ProtectedRoute({ children, allowedRoles }) {
  const { user } = useAuth();
  const location = useLocation();

  // login değilse → login'e
  // Where they were headed goes along, so a shared link opened while signed
  // out still reaches its page after login instead of ending on the channel list.
  if (!user) {
    return <Navigate to="/login" replace state={{ from: location }} />;
  }

  // role kontrolü gerekiyorsa ve uygun değilse → home'a
  if (allowedRoles && !allowedRoles.includes(user.role)) {
    return <Navigate to="/home" replace />;
  }

  return children;
}
